import { useConnectionStatus } from "@/features/tutor/hooks/useConnectionStatus";
import {
  useNotepadStore,
  selectIsNotepadOpen,
} from "@/features/notepad/store/useNotepadStore";
import ConnectionToast from "./ConnectionToast";
import MicToast from "./MicToast";
import PlaybackToast from "./PlaybackToast";
import { NotepadInactivityToast } from "@/features/notepad/components/NotepadInactivityToast";
import { StudentTalkBlockedToast } from "@/features/notepad/components/StudentTalkBlockedToast";
import { CanvasBackToContent } from "@/canvas/components/CanvasPanels";
import { DrawCursor } from "@/drawlock/DrawCursor";

interface SystemToastsProps {
  onMicRetry?: () => void;
  onPlaybackTap?: () => void;
}

const SystemToasts = ({ onMicRetry, onPlaybackTap }: SystemToastsProps) => {
  const { status, showDisconnectedOverlay, wasEverDisconnected } =
    useConnectionStatus();

  // While the notepad is open with the gateway agent, voice flows over the
  // gateway WS — tutor-WS blips don't affect the student, so don't surface
  // them as connection toasts (the canvas panel has its own gateway banners).
  const isNotepadOpen = useNotepadStore(selectIsNotepadOpen);
  const notepadIngressType = useNotepadStore((s) => s.ingressType);
  const usesGatewayVoice = isNotepadOpen && notepadIngressType !== "student";

  if (showDisconnectedOverlay) return null;

  return (
    <>
      {/* Not part of the stack below: draw mode is shown at the pointer, above
          every surface, so it sits outside the toast column entirely. */}
      <DrawCursor />
      <div className="fixed top-[25px] inset-x-0 z-[100] flex flex-col items-center gap-2 pointer-events-none">
        <NotepadInactivityToast />
        <StudentTalkBlockedToast />
        <CanvasBackToContent />
        <MicToast onRetry={onMicRetry} />
        <PlaybackToast onTap={onPlaybackTap} />
        {!usesGatewayVoice && (
          <ConnectionToast
            status={status}
            wasEverDisconnected={wasEverDisconnected}
          />
        )}
      </div>
    </>
  );
};

export default SystemToasts;
